<template>
	<v-card flat max-width="950px" class="mx-auto transparent">
        <v-row class="mt-6 mt-sm-12 pt-sm-12 px-2 px-sm-0" no-gutters>
            <v-col cols="12" sm="6">
                <div class="d-flex justify-center justify-sm-end">
                    <v-card flat class="accent mt-2" width="300" height="200" hover @click="$router.push('/to-do')">
                        <div class="d-flex flex-column align-center justify-center fill-height">
                            <div class="d-flex">
                                <v-icon size="44" color="white" class="mr-4">fa-check-double fa-fw</v-icon>
                                <div class="display-1 font-weight-bold white--text py-8">TO DO</div>
                            </div>
                        </div>
                    </v-card>
                </div>
                <div class="d-flex justify-center justify-sm-end">
                    <v-card flat class="accent mt-2" width="300" height="200" hover @click="$router.push('/to-learn')">
                        <div class="d-flex flex-column align-center justify-center fill-height">
                            <div class="d-flex">
                                <v-icon size="50" color="white" class="mr-4">fa-lightbulb fa-fw</v-icon>
                                <div class="display-1 font-weight-bold white--text py-8">TO <br> LEARN</div>
                            </div>
                        </div>
                    </v-card>
                </div>
            </v-col>

            <v-col cols="12" sm="6">
                <v-card flat class="accent ml-sm-2 mt-2 mx-auto" width="300" :height="($vuetify.breakpoint.xsOnly) ? '200' : '300'" hover @click="$router.push('/my-profile')">
                    <div class="d-flex flex-column align-center justify-center fill-height">
                        <div class="display-1 font-weight-bold white--text text-center py-4">PROFILE</div>
                        <v-icon size="50" color="white">fa-user fa-fw</v-icon>
                    </div>
                </v-card>
                <v-card flat class="primary ml-sm-2 mt-2 mx-auto" width="300px" height="100" hover @click="$router.push('/how-to')">
                    <div class="d-flex flex-column align-center justify-center fill-height">
                        <div class="headline font-weight-bold white--text text-center py-8">HOW TO</div>
                    </div>
                </v-card>
            </v-col>
        </v-row>
	</v-card>
</template>

<script>
import Users from '@/firebase/users'

export default {
    computed: {
        shortName() {
            let tempo = this.user.name;
            return tempo.split(' ')[0];
        }
    },
    mounted() {
        //Users.demoMail();
    },
    methods: {
        openStream() {
            window.open('https://zoom.us/j/845636140');
        }
    }
}
</script>

<style scoped>
    .link-text {
        cursor: pointer;
        text-decoration: underline;
    }
    .link-text:hover {
        color: #FF5A5A;
    }
</style>
